export default "__VITE_ASSET__5f251f7c__"